import { ReactElement } from "react"
import { useParams } from "react-router-dom"

import SingleGenDeviceDisplay from "./singleGenDeviceDisplay"
import DataLoadError from "../../components/fallback/dataLoadError"
import SingleDeviceSkeleton from "../../components/loading/skeletons/singleDeviceSkeleton"
import AppPaper from "../../components/surfaces/appPaper"
import { Datasets } from "../../constants/enums"
import useMultiFetcherGetDevice from "../../services/middleware/hooks/useMultiFetcherGetDevice"

interface IGenUrlParams {
    deviceId: string
}

/**
 * Webpage showing single generation device summary page. Handles API and
 * asynchronous logic and passes it to display component. Relies on `deviceId`
 * url parameter.
 */
const SingleGenDevice = (): ReactElement => {
    const { deviceId } = useParams<keyof IGenUrlParams>() as IGenUrlParams

    const { data, isLoading, isError, mutate, isValidating } =
        useMultiFetcherGetDevice(deviceId, Datasets.TTR)
    if (isLoading && !data) {
        return <SingleDeviceSkeleton />
    }
    if (isError) {
        return (
            <AppPaper>
                <DataLoadError />
            </AppPaper>
        )
    }
    if (!data) {
        return (
            <AppPaper>
                <h1>No data</h1>
            </AppPaper>
        )
    }
    return (
        <SingleGenDeviceDisplay
            data={data}
            mutate={mutate}
            isLoading={isLoading}
            isValidating={isValidating}
        />
    )
}

export default SingleGenDevice
